import { request } from '@tencent/vft-common/request'
import env from '@tencent/vft-common/env'

const platform = getPlat()
const MTYPE_MAP = {
  upcoming: 'type_58'      // 即将上映
}

let cacheList = {}

export async function getFilmList(key) {
  if (cacheList[key]) return Promise.resolve(cacheList[key])
  let idArr = await getModIdArr();
  if (idArr.length == 0) {
    return Promise.resolve(null)
  }
  let res = await getModData(idArr.join("+"))
  if (res && res.ret == 0 && res.data.modList && res.data.modList[0].list.length > 0) {
    res.list = res.data.modList[ 0 ].list
    cacheList[key] = res.list
  }
  return cacheList[key] || null
}

export async function getNewVIPMovie() {
  return request('//node.video.qq.com/x/vip/api/common?_m=vipFilm.getFilm()').then(res => {
    if (!res || !res.data || !res.data.vipFilm) return null
    return res.data.vipFilm.list
  })
}

async function getModIdArr() {
  let result = [];
  const url = 'https://access.video.qq.com/fcgi-bin/GetChannelModList?raw=1&vappid=61550642&vsecret=1e70a5069a0e2388b3a0e9e94451b6d6295452c6039c475a&app_id=10001&app_key=79d5453c74773a510e4f4ffc9b27f02e&channelId=110503'
  let res = await request(url, {
  }, {
    method: 'POST',
    data: {
      vsecret: '1e70a5069a0e2388b3a0e9e94451b6d6295452c6039c475a',
      channelId: "110503",
      platform,
      app_id: "10001",
      app_key: '79d5453c74773a510e4f4ffc9b27f02e',
    }
  });
  if (res.data && res.data.modInfo && res.data.modInfo.length > 0) {
    let list = res.data.modInfo;
    for (let name in MTYPE_MAP) {
      let mtype = MTYPE_MAP[name];
      for (let i = 0, len = list.length; i < len; i++) {
        let mod = list[i];
        if (mod.type == mtype) {
          result.push(mod.meta.ZT_leaf_id);
          break;
        }
      }
    }
  }
  return result
}


async function getModData(leafids) {
  const url = 'https://access.video.qq.com/fcgi-bin/GetChannelModData?raw=1&vappid=61550642&vsecret=1e70a5069a0e2388b3a0e9e94451b6d6295452c6039c475a&app_id=10001&app_key=79d5453c74773a510e4f4ffc9b27f02e&channelId=110503'
  return request(url, {}, {
    method: 'POST',
    data: {
      vsecret: '1e70a5069a0e2388b3a0e9e94451b6d6295452c6039c475a',
      channelId: "110503",
      platform: platform,
      app_id: "10001",
      app_key: '79d5453c74773a510e4f4ffc9b27f02e',
      modId: [leafids],
    }
  }
)
}

// 个性影院
export async function getMyCinema () {
  return request('https://tunnel.video.qq.com/fcgi/cimema_plugin?raw=1&vappid=64118661&vsecret=4428eed95d2bcc7661d3db7e4d73c3bca4f1ae6a91b3c9bd&pageContext=&channelId=100137')
}

export async function getRecommendFilm () {
  let res = await request('//vip.video.qq.com/fcgi-bin/comm_cgi?name=new_hot_albums&cmd=2')
  return res.cid_infos
}

function getPlat () {
  const PLAT = {
    IPAD: 4,
    IPHONE: 5,
    APHONE: 3
  }
  let platform = PLAT.IPHONE;
  if (env.isAndroid) {
    platform = PLAT.APHONE;
  } else if (env.isIpad) {
    platform = PLAT.IPAD;
  }
  return platform;
}